module.exports = __webpack_public_path__ + "media/images/webpage/hotels/9494/plan1-2-c950a444093b313ab16419be880cbe17.webp";